<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'online' && 'active'"
        @click.stop="handleClick('online')"
      >{{ $lang('在线文档') }}</span>
      <!-- <span
        class="main-r_top_nav"
        :class="mainStatus === 'apiTest' && 'active'"
        @click.stop="handleClick('apiTest')"
      >测试工具</span> -->
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'online'">
      <online-doc :onlineData="onlineData"></online-doc>
    </div>
    <!-- 在线文档 END -->
    <!-- 测试工具 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'apiTest'">
      <api-test-doc :apiTestData="apiTestData"></api-test-doc>
    </div>
    <!-- 测试工具 END -->
  </div>
</template>

<script>
import onlineDoc from "../components/onlineDoc";

import apiTestDoc from "../components/apiTestDoc";

import {OPEN_API_TEST,OPEN_API_PRO} from '@/constants/index'
const apiUrlTest = 'realName/saveOrUpdate';
export default {
  components: { onlineDoc , apiTestDoc },
  data() { 
    return {
      mainStatus: "online",
      //当前请求URL
      apiBaseUrl: process.env.VUE_APP_API_URL + `/${apiUrlTest}`,

      onlineData: {
        //接口描述
        apiDesc: "上传散客实名制信息",
        //接口地址
        testApi: `${OPEN_API_TEST}/${apiUrlTest}`,
        proApi: `${OPEN_API_PRO}/${apiUrlTest}`,
        //参数描述  START
       postDataList:[
            
        //   请求头参数
            {
                title:'Headers',
                value:[
                    {name: "apiAccount",type: "Number",require: "Y",normal: "",describe: "接入方可在控制台的应用内查看apiAccount"},
                    {name: "digest",type: "String",require: "Y",normal: "",describe: "签名字符串,请在签名工具内获取"},
                    {name: "timestamp",type: "Number",require: "Y",normal: "",describe: "时间戳，毫秒"}
                    ]
            },
             { 
                title:'请求参数', 
                 value:[
                    {name: "bizContent",type: "String",require: "Y",normal: "业务参数",describe: "业务参数模块内json格式的string类型",},
                ]
            },
            {
              title:"业务参数",
              value:[
                {name: "name",type: "String(30)",require: "Y",normal: "",describe: "个人在公安户籍管理部门正式登记注册的姓名"},
                {name: "sex",type: "String(2)",require: "N",normal: "",describe: "性别，传编号 “01：男 ” “02：女”"},
                {name: "typeOfId",type: "String(2)",require: "Y",normal: "",describe: "个人有效身份证件类型，传代码<p>01：居民身份证</p><p>02：临时居民身份证</p><p>03：户口薄</p><p>04：中国人民解放军军人身份证件</p><p>05：中国人民武装警察 身份证件</p><p>06：港澳居民来往内地 通行证</p><p>07：台湾居民来往大陆通行证</p><p>08：外国公民护照</p><p>09: 中国公民护照</p>"},
                {name: "numberOfId",type: "String(30)",require: "Y",normal: "",describe: "证件号"},
                {name: "mobileNumber",type: "String(30)",require: "Y",normal: "",describe: "个人有效联系电话<p>联系电话固定电话至少填写一个</p>"},
                {name: "phone",type: "String(30)",require: "Y",normal: "",describe: "个人固定联系电话，包括区号、电话号码以及分机号，中间用 - 分隔<p>联系电话固定电话至少填写一个</p>"},
                {name: "province",type: "String(30)",require: "N",normal: "",describe: "地址中的省、自治区或直辖市"},
                {name: "city",type: "String(30)",require: "N",normal: "",describe: "地址中的市"},
                {name: "county",type: "String(30)",require: "N",normal: "",describe: "地址中的县或区"},
                {name: "address",type: "String(200)",require: "N",normal: "",describe: "个人详细地址"},
                {name: "codeOfWeixin",type: "String(100)",require: "N",normal: "",describe: "微信号"},
                {name: "typeOfUser",type: "String(10)",require: "N",normal: "1",describe: "是否协议用户，传编号，如果不传，则默认非协议用户<p>1：非协议用户</p><p>2： 协议用户,修改协议用户为非必填</p>"},
                {name: "collectMethod",type: "String(2)",require: "N",normal: "50",describe: "用户信息采集方式 ，传编号 <p>10：身份证件识别设备</p> <p>20：NFC+SAM 方式</p> <p>30：OCR 读取方式</p> <p>40：用户自助</p> <p>50：收派员手工</p> <p>99：其它</p>"},
                {name: "addressType",type: "String(1)",require: "N",normal: "2",describe: "地址类型，传编号 <p>1：证件地址</p> <p>2：常用地址</p>"},
              ]
            }

        ],
        //参数描述  END
        //报文描述 start
        responseDataList:[
            
        //   响应参数
            {
                title:'响应参数',
                value:[
                    { name: "code",type: "String", require: "Y",normal: "",describe: "返回码，见附录",},
                    {name: "msg",type: "String",require: "Y",normal: "",describe: "描述",},
                    {name: "data",type: "Boolean",require: "Y",normal: "",describe: "业务数据",},
                  ]
            }

        ],
        //请求示例
        requestCode: `Header：
    apiAccount=1627
    digest=U40e5sumorgd3YgZzU61Mw==
    timestamp=1565238848921

Body：
    bizContent= {"name": "哈哈", "sex": "01", "typeOfId": "01", "numberOfId": "420621198601089936", "mobileNumber": "1441213120", "phone": "", "province": "广东省", "city": "深圳市", "county": "南山区", "address": "粤美特1111", "codeOfWeixin": "ylwechat", "typeOfUser": "2", "collectMethod": "99", "addressType": "1"}`,
        //返回示例
        responseCode: JSON.parse(`{
    "code": "1",
    "msg": "success",
    "data": true
}`),

        //错误代码提示
        errcodeJson: [{code:'999001040',msg:"个人联系电话和固定电话不能同时为空"},
        {code:'999001050',msg:"请输入正确的性别编号 男：01 女：02"},
        {code:'999001060',msg:"请输入正确的证件编号"},
        {code:'999001070',msg:"请输入正确的用户协议编号"},
        {code:'999001080',msg:"请输入正确的采集方式编号"},
        {code:'999001090',msg:"请输入正确的地址类型"},
        {code:'999006060',msg:"身份校验失败"}]
      },

      apiTestData: {
          _headerData: {
            apiAccount: "1001",
            digest: "U40e5sumorgd3YgZzU61Mw==",
            timestamp: "1565238848921",
          },
          data:{
             bizContent: `{"name": "哈哈", "sex": "01", "typeOfId": "01", "numberOfId": "420621198601089936", "mobileNumber": "1441213120", "phone": "", "province": "广东省", "city": "深圳市", "county": "南山区", "address": "粤美特1111", "codeOfWeixin": "ylwechat", "typeOfUser": "2", "collectMethod": "99", "addressType": "1"}`,
          },
        //必须要验证的参数
        requestData:['apiAccount','digest','timestamp','bizContent'],
        textareaData:{
          bizContent:true
        },
        //促发接口
        apiUrl: `/mock/${apiUrlTest}`,
        //返回
        ResponseJson: "",
        //当前请求URL
        apiBaseUrl: process.env.VUE_APP_API_URL + `/mock/${apiUrlTest}`,
        //错误代码提示
        errcodeJson: [{code:'999001040',msg:"个人联系电话和固定电话不能同时为空"},
        {code:'999001050',msg:"请输入正确的性别编号 男：01 女：02"},
        {code:'999001060',msg:"请输入正确的证件编号"},
        {code:'999001070',msg:"请输入正确的用户协议编号"},
        {code:'999001080',msg:"请输入正确的采集方式编号"},
        {code:'999001090',msg:"请输入正确的地址类型"},
        {code:'999006060',msg:"身份校验失败"}]
      },
    };
  },
  created() {},
  methods: {
    handleClick(status) {
      this.mainStatus = status;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/apiTest.scss";
</style>